<template>
  <BreadCrumb PageTitle="Packs tarifaires" />
  <PacksSettings />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import PacksSettings from "../../components/Generals/Packs/PacksSettings.vue";
export default defineComponent({
  name: "PacksSettingsPage",
  components: {
    BreadCrumb,
    PacksSettings,
  },
});
</script>
